module.exports = __webpack_public_path__ + "static/img/info.bb90706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/info.jpg
// module id = /HGr
// module chunks = 0